import React from "react";

interface InlineProgressProps {
    value: number;           // 0–100
    height?: number;         // px, default 6
    showLabel?: boolean;     // shows "Progress" + %
    accentColor?: string;    // default #c79656
    trackColor?: string;     // default #F3F4F6
    ariaLabel?: string;      // default "Progress"
}

export default class InlineProgressBar extends React.Component<InlineProgressProps> {
    render() {
        const {
            value,
            height = 6,
            showLabel = false,
            accentColor = "#c79656",
            trackColor = "#F3F4F6",
            ariaLabel = "Progress"
        } = this.props;

        const clamped = Math.max(0, Math.min(100, value));
        const radius = Math.max(2, Math.round(height / 2));

        return (
            <div style={{ display: "grid", gap: showLabel ? 6 : 0, width: "100%", minWidth: 0 }}>
                <div
                    aria-label={ariaLabel}
                    role="progressbar"
                    aria-valuemin={0}
                    aria-valuemax={100}
                    aria-valuenow={Math.round(clamped)}
                    style={{
                        width: "100%",
                        height,
                        background: trackColor,
                        borderRadius: radius,
                        border: "1px solid #EAECEF",
                        overflow: "hidden",
                        boxSizing: "border-box"
                    }}
                >
                    <div
                        style={{
                            width: `${clamped}%`,
                            height: "100%",
                            background: accentColor,
                            borderRadius: radius,
                            transition: "width 220ms ease",
                            // prevent subpixel gaps on some browsers
                            transform: "translateZ(0)"
                        }}
                    />
                </div>

                {showLabel && (
                    <div style={{ display: "flex", justifyContent: "space-between", fontSize: 12, color: "#6B7280" }}>
                        <span>{ariaLabel}</span>
                        <span>{Math.round(clamped)}%</span>
                    </div>
                )}
            </div>
        );
    }
}
